import { EventEmitter, Injectable } from '@angular/core';
import { User, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { Subject, Observable } from 'rxjs';
import * as Oidc from 'oidc-client';
import { ConstService } from './const.service';
import { Md5 } from 'ts-md5/dist/md5';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApplicationUser, ApplicationUserClass } from '../../../models/applicationUser';
import { decode } from 'jsonwebtoken';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: User;
  userReady: boolean;
  userManager: UserManager;
  appUser: ApplicationUser;
  loginChangedSubject = new Subject<boolean>();
  loginChanged = this.loginChangedSubject.asObservable();
  silentLoginEmitter = new EventEmitter();
  private clientId = 'angular';

  constructor(private constService: ConstService, private httpClient: HttpClient,
              private cookieService: CookieService) {

    this.userReady = false;

    const stsSetting: UserManagerSettings = {
      authority: constService.getAuthUri(),
      client_id: this.clientId,
      client_secret: 'secret',
      redirect_uri: `${constService.getClientUri()}/signin-callback`,
      // automaticSilentRenew: true,
      silent_redirect_uri: `${constService.getClientUri()}/assets/silent-callback.html`,
      scope: 'openid profile CedLabWebApi',
      response_type: 'code',
      post_logout_redirect_uri: `${constService.getClientUri()}/signout-callback`,
      loadUserInfo: true,
      // userStore: new RedisStorage(httpClient, constService)
      userStore: new WebStorageStateStore({store: localStorage})
    };

    this.userManager = new UserManager(stsSetting);

    // this.userManager.events.addAccessTokenExpiring( () => {
    //     console.log('token expiring');
    //   }
    // );

    this.userManager.events.addAccessTokenExpired(() => {
      console.log('token expired');
      this.loginChangedSubject.next(false);
    });

    Oidc.Log.logger = console;
  }

  //#region //* LOGIN
  public login() {
    return this.userManager.signinRedirect();
  }

  public isLoggedIn(): Promise<boolean> {
    return this.userManager.getUser().then(user => {
      const userCurrent = !!user && !user.expired;
      if (this.user !== user) {
        this.loginChangedSubject.next(userCurrent);
      }
      this.user = user;
      setTimeout(() => {
        this.userReady = true;
      }, 2000);
      return userCurrent;
    });
  }

  public completeLogin() {
    return this.userManager.signinRedirectCallback().then(user => {
      this.user = user;
      this.loginChangedSubject.next(!!user && !user.expired);
      return user;
    });
  }

  public isLoggedInSts() {
    // localStorage.removeItem('oidc.user:authId');
    return this.userManager.signinSilent().then(user => {
      this.isLoggedIn().then(isLogged => {
        if (isLogged) {
          this.silentLoginEmitter.emit(this.user);
        }
      }, err => {
        console.log('errore su isLoggedIn', err);
      });
    }).catch(err => console.log('errore su signin silent', err));
  }
  //#endregion

  //#region //* LOGOUT
  public logout() {
    return this.userManager.signoutRedirect();
  }

  public completeLogout() {
    return this.userManager.signoutRedirectCallback().then(response => {
      this.loginChangedSubject.next(false);
      return response;
    });
  }
  //#endregion

  //#region //* REGISTRATION
  public registrationRequest() {
    const md5 = new Md5();
    const hash = md5.appendStr(this.userManager.settings.client_id).end().toString();

    const queryParams = new HttpParams()
      .set('client_id', hash);

    return new Observable(observer => {
      this.httpClient.get(this.constService.registrationRequestUri(), { params: queryParams })
        .subscribe(
          res => observer.next(res),
          error => observer.error(error)
        );
    });
  }

  public createAccount(data: any, gRecaptcha: string) {
    const queryParams = new HttpParams()
      .set('gRecaptcha', gRecaptcha);

    return new Observable(observer => {
      this.httpClient.post(this.constService.registrationUri(), data, { params: queryParams })
        .subscribe(
          account => observer.next(account),
          error => observer.error(error)
        );
    });
  }

  public addUser(userModel: any) {
    const md5 = new Md5();
    const hash = md5.appendStr(this.userManager.settings.client_id).end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash);

    return new Observable(observer => {
      this.httpClient.post(this.constService.newAccountUri, userModel, { params: queryParams })
        .subscribe(
          account => observer.next(account),
          error => observer.error(error)
        );
    });
  }
  //#endregion

  //#region //* EMAIL
  public confirmEmail(token: string, email: string, clientId: string) {
    const queryParams = new HttpParams()
      .set('token', token)
      .set('email', email)
      .set('clientId', clientId);

    return new Observable(observer => {
      this.httpClient.post(this.constService.emailConfirmationUri(), {}, { params: queryParams })
        .subscribe(
          response => observer.next(response),
          error => observer.error(error)
        );
    });
  }

  public changeEmail(model: any): Promise<boolean> {
    const md5 = new Md5();
    const hash = md5.appendStr(this.userManager.settings.client_id).end().toString();
    model.clientId = hash;

    return new Promise((resolve, reject) => {
      this.httpClient.post(this.constService.changeEmailUri, model)
        .toPromise()
        .then(
          () => resolve(true),
          (error: any) => reject(error)
        );
    });
  }
  // public changeEmail() {
  //   const md5 = new Md5();
  //   const hash = md5.appendStr(this.userManager.settings.client_id).end().toString();
  //   window.location.href = this.constService.getChangeEmailUri() + hash + '&userId=' + this.user.profile.sub;
  // }

  public completeChangeEmail() {
    const cookie = this.cookieService.get('ChangeEmailCookie');
    const decodedCookie = decode(cookie);
    this.appUser = new ApplicationUserClass();
    // this.appUser = {};
    this.appUser.Email = decodedCookie?.Email;
    // API CALL
    this.httpClient.patch(this.constService.getProfileUri(), this.appUser).subscribe();
  }
  //#endregion

  //#region //* PASSWORD
  public changePasswordRequest(model: any): Promise<any> {
    const md5 = new Md5();
    const hash = md5.appendStr(this.userManager.settings.client_id).end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash);

    return new Promise((resolve, reject) => {
      this.httpClient.post(this.constService.changePasswordRequestUri, model, { params: queryParams })
        .toPromise()
        .then(
          () => resolve(true),
          (error: any) => reject(error)
        );
    });
  }

  changePassword(resetModel: any) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(this.constService.changePasswordUri, resetModel)
        .toPromise()
        .then(
          () => resolve(true),
          (error: any) => reject(error)
        );
    });
  }
  //#endregion

  public getClientId = () => this.clientId;

  public getIdentifiers() {
    const md5 = new Md5();
    const hash = md5.appendStr(this.userManager.settings.client_id).end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash);

    return new Observable(observer => {
      this.httpClient.get(this.constService.identifiersUri, { params: queryParams })
        .subscribe(
          (res: { usernames: string[], emails: string[] }) => observer.next(res),
          error => observer.error(error)
        );
    });
  }

  getAccessToken() {
    return this.userManager.getUser().then(user => {
      if (!!user && !user.expired) {
        return user.access_token;
      }
      return null;
    });
  }

  startSilentRenew() {
    this.userManager.startSilentRenew();
  }

  stopSilentRenew() {
    this.userManager.stopSilentRenew();
  }

}
